import FormattedMessage from 'I18n/components/FormattedMessage';
import UICardHeader from 'UIComponents/card/UICardHeader';
import UICardSection from 'UIComponents/card/UICardSection';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UIRibbon from 'UIComponents/ribbon/UIRibbon';
import UIExpandableText from 'UIComponents/text/UIExpandableText';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CollectionCard({
  className,
  collection,
  maxHeight
}) {
  if (!collection.publishedListing) {
    return null;
  }
  return /*#__PURE__*/_jsxs(UICardWrapper, {
    className: className,
    compact: true,
    children: [/*#__PURE__*/_jsx(UIRibbon, {
      use: "calypso",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-common.collections.collectionLabel"
      })
    }), /*#__PURE__*/_jsx(UICardHeader, {
      className: "m-top-4",
      title: collection.publishedListing.name,
      titleSize: "small"
    }), /*#__PURE__*/_jsx(DescriptionWrapper, {
      maxHeight: maxHeight,
      children: /*#__PURE__*/_jsx(SanitizedText, {
        body: collection.publishedListing.description,
        WrapperComponent: "span"
      })
    })]
  });
}
function DescriptionWrapper({
  children,
  maxHeight
}) {
  if (maxHeight === undefined) {
    return /*#__PURE__*/_jsx(UICardSection, {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(UICardSection, {
    className: "p-bottom-2",
    children: /*#__PURE__*/_jsx(UIExpandableText, {
      onCollapseButtonClick: e => e.preventDefault(),
      onExpandButtonClick: e => e.preventDefault(),
      maxHeight: maxHeight,
      children: children
    })
  });
}